import React from 'react';
import View from './view';

const Index = () => {
    return <View />;
};

export default Index;
